import React, { useState } from 'react';
import { X, Check, Zap, CreditCard, Shield, ChevronRight, Star } from 'lucide-react';
import { ref, set } from 'firebase/database';
import { database } from '../../firebase';
import { COURSE_PERIODS } from '../../data/coursesData';
import '../../styles/CursosVortex.css';

// Plan único: acceso a TODOS los cursos del periodo en curso (un solo pago).
export const VORTEX_PLANS = [
  {
    id: 'curso_periodo',
    label: 'Periodo en curso',
    icon: '🎓',
    price: 300,
    duration: 'Todo el periodo',
    durationDays: 0,
    badge: 'Acceso completo',
    badgeColor: '#c5a059',
    savings: '',
    recommended: true,
    stripeUrl: 'https://buy.stripe.com/7sY6oHbyo90C7ZEcLD73G0g',
  },
];

export const CoursePlanModal = ({
  isOpen,
  onClose,
  course,
  user,
  isAuthenticated,
  onRequireAuth,
}) => {
  const [selectedPlanId, setSelectedPlanId] = useState('curso_periodo');

  if (!isOpen) return null;

  const selectedPlan = VORTEX_PLANS.find(p => p.id === selectedPlanId);

  const encodeEmail = (email) => (email || '').replace(/\./g, '_dot_').replace(/@/g, '_at_');

    const handleCheckout = async () => {
    if (!isAuthenticated) {
      onClose();
      onRequireAuth();
      return;
    }
    if (!selectedPlan) return;

    const userEmail = user?.email || '';
    const userId   = user?.uid || '';
    const now = Date.now();

    const activePeriod = COURSE_PERIODS.find(p => p.active) || COURSE_PERIODS[0];

    // Guardar el pago pendiente para que el webhook de Stripe active el
    // acceso al periodo en curso (cursoPeriodoAcceso), NO una licencia premium.
    try {
      await set(ref(database, `stripe_pending/${encodeEmail(userEmail)}`), {
        uid: userId,
        email: userEmail,
        tipo: 'curso_periodo',
        planId: 'curso_periodo',
        planName: 'Acceso a Cursos por Periodo',
        amount: selectedPlan.price,
        periodo: activePeriod ? activePeriod.id : 'p1',
        initiatedAt: now,
        status: 'pending',
      });
    } catch (err) {
      console.error('[CoursePlanModal] Error guardando pago pendiente:', err);
    }

    const url = `${selectedPlan.stripeUrl}?client_reference_id=${encodeURIComponent(userId)}&prefilled_email=${encodeURIComponent(userEmail)}`;
    window.location.href = url;
  };

  return (
    <div className="vx-modal-overlay" onClick={onClose}>
      <div
        className="vx-modal-card"
        style={{ maxWidth: '560px' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: '1.25rem 1.5rem',
          borderBottom: '1px solid rgba(197,160,89,0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'linear-gradient(135deg, #0f2035 0%, #0a1a2a 100%)',
          flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '38px', height: '38px',
              borderRadius: '10px',
              background: 'rgba(197,160,89,0.15)',
              border: '1px solid rgba(197,160,89,0.35)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'var(--gold-matte)',
            }}>
              <Shield size={18} />
            </div>
            <div>
              <p style={{ fontSize: '0.7rem', color: 'var(--text-muted)', fontFamily: 'monospace', margin: 0 }}>
                LICENCIA CURSOS VORTEX
              </p>
              <h3 style={{
                fontFamily: 'var(--font-tactical)',
                fontSize: '0.95rem',
                color: '#fff',
                margin: 0,
                lineHeight: 1.2,
              }}>
                {course?.title
                  ? course.title.length > 38
                    ? course.title.substring(0, 38) + '…'
                    : course.title
                  : 'Acceso al Curso'}
              </h3>
            </div>
          </div>
          <button className="btn-vx-modal-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '1.25rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem', overflowY: 'auto' }}>

          {/* Info explicativa */}
          <div style={{
            padding: '12px 14px',
            borderRadius: '10px',
            background: 'rgba(197,160,89,0.07)',
            border: '1px solid rgba(197,160,89,0.25)',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
          }}>
            <Zap size={15} style={{ color: 'var(--gold-matte)', flexShrink: 0, marginTop: '2px' }} />
            <p style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', margin: 0, lineHeight: 1.6 }}>
              Paga una sola vez el acceso a <strong style={{ color: '#fff' }}>todos los cursos del periodo en curso</strong>.
              Al completar el pago se activará tu acceso automáticamente y estará disponible hasta que termine el periodo;
              al iniciar el siguiente periodo deberás adquirirlo de nuevo.
            </p>
          </div>

          {/* Planes */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {VORTEX_PLANS.map(plan => {
              const isSelected = plan.id === selectedPlanId;
              return (
                <div
                  key={plan.id}
                  onClick={() => setSelectedPlanId(plan.id)}
                  style={{
                    padding: '14px 16px',
                    borderRadius: '12px',
                    border: isSelected
                      ? '2px solid var(--gold-matte)'
                      : '1px solid rgba(197,160,89,0.18)',
                    background: isSelected ? 'rgba(197,160,89,0.08)' : '#0f2035',
                    cursor: 'pointer',
                    transition: 'border-color 0.2s ease, background-color 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px',
                    position: 'relative',
                  }}
                >
                  {/* Icono Plan */}
                  <span style={{ fontSize: '1.4rem', lineHeight: 1, flexShrink: 0 }}>
                    {plan.icon}
                  </span>

                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      <span style={{
                        fontFamily: 'var(--font-tactical)',
                        fontSize: '0.88rem',
                        fontWeight: 700,
                        color: isSelected ? 'var(--gold-matte)' : '#fff',
                      }}>
                        {plan.label}
                      </span>
                      {/* Badge */}
                      <span style={{
                        fontSize: '0.62rem',
                        fontWeight: 700,
                        padding: '2px 7px',
                        borderRadius: '4px',
                        background: plan.recommended ? plan.badgeColor : `${plan.badgeColor}22`,
                        color: plan.recommended ? '#fff' : plan.badgeColor,
                        border: `1px solid ${plan.badgeColor}55`,
                        fontFamily: 'monospace',
                        letterSpacing: '0.04em',
                        textTransform: 'uppercase',
                      }}>
                        {plan.recommended && <Star size={8} style={{ display: 'inline', marginRight: '2px' }} />}
                        {plan.badge}
                      </span>
                    </div>
                    <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '2px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      <span>Acceso por <strong style={{ color: isSelected ? '#fff' : 'var(--text-secondary)' }}>{plan.duration}</strong></span>
                      {plan.savings && (
                        <span style={{ color: '#34d399', fontWeight: 600 }}>· {plan.savings}</span>
                      )}
                    </div>
                  </div>

                  {/* Precio + selector */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
                    <div style={{ textAlign: 'right' }}>
                      <span style={{
                        fontFamily: 'var(--font-tactical)',
                        fontSize: '1.1rem',
                        fontWeight: 800,
                        color: isSelected ? 'var(--gold-matte)' : '#fff',
                      }}>
                        ${plan.price.toLocaleString()}
                      </span>
                      <span style={{ fontSize: '0.65rem', color: 'var(--text-muted)', display: 'block', textAlign: 'right' }}>
                        MXN
                      </span>
                    </div>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      border: isSelected ? '2px solid var(--gold-matte)' : '2px solid rgba(197,160,89,0.3)',
                      background: isSelected ? 'var(--gold-matte)' : 'transparent',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      transition: 'border-color 0.2s ease, background-color 0.2s ease',
                    }}>
                      {isSelected && <Check size={12} style={{ color: '#0a1a2a' }} />}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Métodos de pago */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '0.7rem',
            color: 'var(--text-muted)',
            justifyContent: 'center',
          }}>
            <Shield size={12} style={{ color: '#34d399' }} />
            <span>Pago seguro vía Stripe · Tarjeta, OXXO y más · Sin datos almacenados</span>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '1rem 1.5rem',
          borderTop: '1px solid rgba(197,160,89,0.2)',
          background: '#0a1a2a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          flexShrink: 0,
          flexWrap: 'wrap',
        }}>
          <div>
            <span style={{ fontSize: '0.7rem', color: 'var(--text-muted)', display: 'block', fontFamily: 'monospace' }}>
              Plan seleccionado:
            </span>
            <span style={{ fontFamily: 'var(--font-tactical)', fontSize: '0.9rem', color: 'var(--gold-matte)' }}>
              {selectedPlan?.label} — ${selectedPlan?.price?.toLocaleString()} MXN
            </span>
          </div>

          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button
              className="btn-card-resumen"
              onClick={onClose}
              style={{ padding: '10px 18px', fontSize: '0.78rem' }}
            >
              Cancelar
            </button>
            <button
              className="btn-vx-action"
              onClick={handleCheckout}
              style={{ padding: '10px 22px', gap: '8px' }}
            >
              <CreditCard size={15} />
              <span>
                {isAuthenticated
                  ? `Ir a Stripe · $${selectedPlan?.price?.toLocaleString()} MXN`
                  : 'Iniciar Sesión para Comprar'}
              </span>
              <ChevronRight size={14} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
